// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/userHome/emailTemplates/emailTemplates.component.less
// module id = 446
// module chunks = 0